export default __webpack_public_path__ + "static/media/sapto.eecac878.webp";